module.exports = __webpack_public_path__ + "img/Antonia&Stephan-16.074b2f78.jpg";